/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Doc_List_EmptyInputs */

const en_doc_list_empty = /** @type {(inputs: Doc_List_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No documents uploaded yet.`)
};

const pt_br2_doc_list_empty = /** @type {(inputs: Doc_List_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum documento enviado ainda.`)
};

/**
* | output |
* | --- |
* | "No documents uploaded yet." |
*
* @param {Doc_List_EmptyInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const doc_list_empty = /** @type {((inputs?: Doc_List_EmptyInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Doc_List_EmptyInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_doc_list_empty(inputs)
	return pt_br2_doc_list_empty(inputs)
});